import { createSelector } from 'reselect';
import { compose, get, isEmpty } from 'lodash/fp';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getOrEmptyObject } from '@mews-commander/utils';
import EnterpriseBuilderScreenStep from '../EnterpriseBuilderScreenStep';
import { moduleSelector } from '../module';
import { getCategories } from './categories';
import { getFloors } from './floors';
import { getEnterpriseSettings } from './settings';

export const getAllSteps = createSelector(moduleSelector, getOrEmptyObject('steps'));
export const getCurrentStep = compose(get('currentStep'), getAllSteps);

export const getOptions = createSelector(
    getEnterpriseSettings,
    getFloors,
    getCategories,
    getCurrentStep,
    (settings, floors, categories, currentStep) => [
        {
            primaryText: <LocalizedText textKey={TextKey.Dashboard} />,
            value: EnterpriseBuilderScreenStep.Dashboard,
            shouldUseValueAsLink: false,
        },
        {
            primaryText: <LocalizedText textKey={TextKey.EnterpriseSettings} />,
            value: EnterpriseBuilderScreenStep.Enterprise,
            disabled: isEmpty(settings),
            shouldUseValueAsLink: false,
        },
        {
            primaryText: <LocalizedText textKey={TextKey.ResourceCategoryPlural} />,
            value: EnterpriseBuilderScreenStep.ResourceCategories,
            disabled: isEmpty(settings),
            shouldUseValueAsLink: false,
        },
        {
            primaryText: <LocalizedText textKey={TextKey.FloorPlural} />,
            value: EnterpriseBuilderScreenStep.Floors,
            disabled:
                currentStep !== EnterpriseBuilderScreenStep.Floors &&
                currentStep !== EnterpriseBuilderScreenStep.ResourceOverviewGrid &&
                isEmpty(categories),
            shouldUseValueAsLink: false,
        },
        {
            primaryText: <LocalizedText textKey={TextKey.ResourcePlural} />,
            value: EnterpriseBuilderScreenStep.ResourceOverviewGrid,
            disabled: currentStep !== EnterpriseBuilderScreenStep.ResourceOverviewGrid && isEmpty(floors),
            shouldUseValueAsLink: false,
        },
    ]
);
